import { WizardContext } from '../wizardMachine'

export const isFirstApplicant = (context: WizardContext): boolean => {
  return context.index === 0
}
